module.exports = __webpack_public_path__ + "static/media/Box Shooter.ce6957ef.png";